/**
 * Reacao global ao 403 PAGAMENTO_BLOQUEADO da API.
 *
 * Fica em arquivo proprio, encadeando um SEGUNDO interceptor na instancia de
 * utils/axios.js (o axios aceita varios), em vez de editar aquele arquivo: ele
 * diverge entre as branches de cliente e e compartilhado com o app do cliente
 * final.
 *
 * Este interceptor NAO abre modal nenhum — so marca o estado e repassa o erro.
 * Quem renderiza e o AvisoPagamento.vue, montado dentro do Layout do sistema.
 * E o que garante que o celular do cliente no salao, que usa esta mesma
 * instancia de axios em /app, nunca veja a cobranca do dono.
 */

import axios from "@/utils/axios";
import { marcarBloqueado } from "@/utils/travaPagamento";

axios.interceptors.response.use(
  (res) => res,
  (error) => {
    const data = error && error.response && error.response.data;
    const erro = data && data.error;
    if (
      error.response &&
      error.response.status === 403 &&
      erro &&
      erro.code === "PAGAMENTO_BLOQUEADO"
    ) {
      marcarBloqueado(erro);
    }
    // OPERACAO_INDISPONIVEL (app do cliente) passa direto: a propria tela ja
    // mostra `message`, e nao ha nada de cobranca a exibir ali.
    return Promise.reject(error);
  }
);
